import React, { useState } from 'react';
import {
    Box,
    Button,
    Tab,
    Tabs,
    Typography,
} from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useNavigate } from 'react-router-dom';

import WidgetsDropdown from '../../../layout/WidgetsDropdown';
import { FilterwIcon, ExportIcon, OrganizeIcon, ShareIcon, ScheduleIcon } from '../../../icons';
import DateRangePicker from '../../../components/Date-range-picker/DateRangePicker';
import SummaryList from '../SummaryList';
import MemberUsageBarChart from '../../../components/chart/MemberUsageBarChart';
import DailyTotalsTable from '../../../components/DailyTotals/DailyTotalsTable';
import MonthlyBarChart from '../MonthlyBarChart';

import AmountsFilter from '././../AmountsOwedReport/AmountsFilter';
import ScheduleReport from '../../../components/Projects/ScheduleReport'
import ShareReport from '../../../components/Projects/ShareReport';
import ExportFile from '../../../pages/report/app-url-report/ExportFile';
function CustomTabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


const DailyTotals = () => {
    const navigate = useNavigate();
    const [value, setValue] = useState(0); // Tab value
    const isMeView = value === 0
    const isAllView = value === 1
    const [anchorEl, setAnchorEl] = useState(null); // Menu anchor
    const [selectedOption, setSelectedOption] = useState('Date'); // Organize by

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [openShareReport, setOpenShareReport] = useState(false);
    const [openScheduleReport, setOpenScheduleReport] = useState(false);



    return (
        <>
            <ScheduleReport open={openShareReport} onClose={() => setOpenShareReport(false)} />

            <Box>
                <Button
                    onClick={() => navigate('/reports')}
                    style={{
                        color: '#1A1F36',
                        fontSize: '24px',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        marginBottom: '24px',
                        textTransform: 'capitalize',
                        padding: '0',
                        marginLeft: '-10px'
                    }}
                >
                    <KeyboardArrowLeftIcon
                        sx={{ color: '#1760EC', width: '30px', height: '30px' }}
                    />
                    Reports
                </Button>
            </Box>

            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6" fontWeight="600" sx={{ fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '16px' } }}>
                    Daily totals report (Weekly)
                </Typography>
                <Box className="d-flex gap-10 align-items-center">
                    {/* Widgets & Scheduled Button */}
                    <WidgetsDropdown
                        widgetOptions={[
                            'Member',
                            'Info',
                            'Employment',
                            'Project',
                            'Time',
                            'Activity',
                            'Manual hours',
                            'Idle (%)',
                            'Idle (hr)',
                            'Spent',
                            'Notes',
                        ]}
                        defaultSelected={[
                            'Employment',
                            'Project',
                            'Time',
                            'Activity',
                            'Manual hours',
                            'Idle (%)',
                        ]}
                    />
                    <Button
                        variant="contained"
                        sx={{
                            borderRadius: '30px',
                            textTransform: 'capitalize',
                            fontSize: '16px',
                            padding: '3px 20px',
                            background: '#0076FE',
                        }}
                        onClick={() => navigate('/scheduled-reports')}
                    >
                        Scheduled reports
                    </Button>
                </Box>
            </Box>

            {/* Tabs */}
            <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'inline-block' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Me" {...a11yProps(0)} />
                    <Tab label="All" {...a11yProps(1)} />
                </Tabs>
            </Box>

            <Box className="mt-24" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                <DateRangePicker />
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {/* <Button
                        component="label"
                        variant="contained"
                        sx={{
                            borderRadius: '50px',
                            fontSize: '14px',
                            background: '#0076FE',
                            border: '1px solid #0076FE',
                            color: '#fff',
                            boxShadow: 'none',
                        }}
                        tabIndex={-1}
                        startIcon={<FilterwIcon />}
                    >
                        Filter
                    </Button> */}
                    <AmountsFilter />
                    <Button
                        component="label"
                        variant="contained"
                        sx={{
                            borderRadius: '50px',
                            fontSize: '14px',
                            background: '#fff',
                            border: '1px solid #E5E8EB',
                            color: '#64748B',
                            boxShadow: 'none',
                        }}
                        tabIndex={-1}
                        startIcon={<ShareIcon />}

                        onClick={() => setOpenScheduleReport(true)}
                    >
                        Share
                    </Button>
                    <ShareReport open={openScheduleReport} onClose={() => setOpenScheduleReport(false)} />

                    <Button
                        component="label"
                        variant="contained"
                        sx={{
                            borderRadius: '50px',
                            fontSize: '14px',
                            background: '#fff',
                            border: '1px solid #E5E8EB',
                            color: '#64748B',
                            boxShadow: 'none',
                        }}
                        tabIndex={-1}
                        startIcon={<ScheduleIcon />}
                        onClick={() => setOpenShareReport(true)}
                    >
                        Schedule
                    </Button>

                    <ExportFile />
                </Box>
            </Box>

            <Box className="mt-24"><SummaryList showLabels={
                value === 0
                    ? [
                        'Projects Worked',
                        'Avg. Hours Per Day',
                        'Avg. Activity',
                        'Amount Earned',
                    ]
                    : [
                        'Members Worked',
                        'Total Worked Time',
                        'Avg. Hours Per Member',
                        'Avg. Activity',
                        'Amount Spent',
                    ]
            } /></Box>


            {/* Me Tab */}
            <CustomTabPanel value={value} index={0}>
                <Box className="card-body p-20 bg-base border rounded-3 mt-24">
                    <MonthlyBarChart />
                </Box>
                <Box className="mt-24">
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box className="mb-24">
                            <Typography sx={{ color: '#1A1F36', fontSize: '17px', fontWeight: 600 }}>
                                Acadecraft Private Limited
                            </Typography>
                            <Typography sx={{ fontSize: '14px', color: '#9095A1' }}>Asia - Kolkata</Typography>
                        </Box>
                    </Box>
                </Box>
                <DailyTotalsTable isMeView={isMeView} />
            </CustomTabPanel>

            {/* All Tab */}
            <CustomTabPanel value={value} index={1}>
                <Box className="card-body p-20 bg-base border rounded-3 mt-24">
                    <MemberUsageBarChart />
                </Box>
                <Box className="mt-24">
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box className="mb-24">
                            <Typography sx={{ color: '#1A1F36', fontSize: '24px', fontWeight: 600 }}>
                                Acadecraft Private Limited
                            </Typography>
                            <Typography sx={{ fontSize: '14px', color: '#9095A1' }}>Asia - Kolkata</Typography>
                        </Box>
                    </Box>
                </Box>
                <DailyTotalsTable isAllView={isAllView} />
            </CustomTabPanel>
        </>
    );
};

export default DailyTotals;
